export type EnumLiteralsOf<T extends object> = T[keyof T];

export type AttoDeskStores = EnumLiteralsOf<typeof AttoDeskStores>;

export const AttoDeskStores = Object.freeze({
  DEFAULT: "DEFAULT" as const,
  PRODUCT: "PRODUCT" as const,
  CATEGORY: "CATEGORY" as const,
  // SALEDETAILS: 'SALEDETAILS' as const,
});

export const Level = Object.freeze({
  1: "1" as const,
  2: "2" as const,
  3: "3" as const,
  4: "4" as const,
});

export const Grade = Object.freeze({
  A: "A" as const,
  B: "B" as const,
  C: "c" as const,
  D: "D" as const,
});

export const PaymentMethod = Object.freeze({
  PAD: "PAD" as const,
  DSSAB: "DSSAB" as const,
  Chq: "Chq" as const,
  EFT: "EFT" as const,
  PGT: "PGT" as const,
  Cash: "Cash" as const,
  ODSP: "ODSP" as const,
  LMR: "LMR" as const,
  BISNO: "BISNO" as const,
});

export const PaymentMethod2 = Object.freeze({
  DirectDeposit: "Direct Deposit" as const,
  Cheque: "Cheque" as const,
  Both: "Both" as const,
});

export const Gender = Object.freeze({
  Male: "Male" as const,
  Female: "Female" as const,
});

export const Relationship = Object.freeze({
  Son: "Son" as const,
  Daughter: "Daughter" as const,
  Grandson: "Grandson" as const,
  Granddaughter: "Granddaughter" as const,
  Spouse: "Spouse" as const,
  Sibling: "Sibling" as const,
  Friend: "Friend" as const,
  Other: "Other" as const,
});

export const PaymentStatus = Object.freeze({
  Pending: "pending" as const,
  Paid: "paid" as const,
});

export const TableColumnTypeLevel = Object.freeze({
  string: "string" as const,
  integer: "integer" as const,
  boolean: "boolean" as const,
  // date: 3 as const,
});

export const TableColumnFieldLevel = Object.freeze({
  TextField: "TextField" as const,
  Switch: "Switch" as const,
  Selector: "Selector" as const,
  // MultipleSelector: "MultipleSelector" as const,
  // date: 3 as const,
});

export const ItemServiceChargeType = Object.freeze({
  None: 0 as const,
  Pay: 1 as const,
});

export const RooleType = Object.freeze({
  FOOD: 1 as const,
  Beverages: 2 as const,
  Alcohol: 3 as const,
  Desserts: 4 as const,
});

// export const SizeOfLevelType = Object.freeze({
//   Bottle: 1 as const,
//   Combo: 2 as const,
//   Each: 3 as const,
//   gal: 4 as const,
//   gm: 5 as const,
//   kg: 6 as const,
//   Large: 7 as const,
//   li: 8 as const,
//   lb: 9 as const,
//   Medium: 10 as const,
//   oz: 11 as const,
//   small: 12 as const,
// });

export const SizeOfLevelType = Object.freeze({
  Bottle: 1 as const,
  Each: 2 as const,
  kg: 3 as const,
  lb: 9 as const,
  Large: 4 as const,
  li: 5 as const,
  Medium: 6 as const,
  small: 7 as const,
  case : 8 as const,
});

export const PunchStatus = Object.freeze({
  punch_in: "punch_in" as const,
  punch_out: "punch_out" as const,
});

export const Privileges = Object.freeze({
  DashboardView: "Dashboard_View" as const,
  KitchenView: "Kitchen_View" as const,
  MainItemsView: "Main_Items_View" as const,
  ItemsView: "Items_View" as const,
  CategoriesView: "Categories_View" as const,
  LoopingView: "Looping_View" as const,
  StoreView: "Store_View" as const,
  SettingView: "Setting_View" as const,
  UserView: "User_View" as const,
  CompanyView: "Company_View" as const,
  DepartmentView: "Department_View" as const,
  OrderList: "Order_List" as const,
  UserRoleView: "User_Role_View" as const,
  PrivilegeView: "Privilege_View" as const,
  OrderListManagerApproved: "Order_List_Manager_Approved" as const,
  BranchView: "Branch_View" as const,
  ThemeView: "Theme_View" as const,
  TaxView: "Tax_View" as const,
  OtherView: "Other_View" as const,
  PrinterView: "printer_View" as const,
  TagView: "tag_View" as const,
  BrandView: "brand_View" as const,
  EmailView: "email_view" as const,


  PunchDetailsView: "PunchDetails_View" as const,
  ScheduleView: "Schedule_View" as const,
  PayrollView: "Payroll_View" as const,
  StaffView: "Staff_View" as const,
  PositionView: "Position_View" as const,
  ScheduleEdit: "Schedule_Edit" as const,
  GeneratePayroll: "Generate_Payroll" as const,

});

export const UserRole = Object.freeze({
  Admin: 2 as const,
  User: 3 as const,
});

export const RoomType = Object.freeze({
  S: "S" as const,
  "1B": "1B" as const,
  "1B+": "1B+" as const,
  "2B": "2B" as const,
  "2B+": "2B+" as const,
});

export const OrderListStatus = Object.freeze({
  "OrderListCreated": "OrderListCreated" as const,
  "SentToManager": "SentToManager" as const,
  "ManagerApproved": "ManagerApproved" as const,
  // "ManagerConfirmed": "ManagerConfirmed" as const,
  "Processed": "Processed" as const,
  "Completed": "Completed" as const,
  "Rejected": "Rejected" as const,
 
});

export const OrderListStatus2 = Object.freeze({
  "SentToManager": "SentToManager" as const,
  "ManagerApproved": "ManagerApproved" as const,
  "UpdatedPrice": "UpdatedPrice" as const,
  // "ManagerConfirmed": "ManagerConfirmed" as const,
  "Processed": "Processed" as const,
  "Completed": "Completed" as const,
  "Rejected": "Rejected" as const,
 
});

export const OrderListStatusList = Object.freeze({
  "OrderListCreated": "OrderListCreated" as const,
  "SentToManager": "SentToManager" as const,
  "ManagerApproved": "ManagerApproved" as const,
  "UpdatedPrice": "UpdatedPrice" as const,
  // "ManagerConfirmed": "ManagerConfirmed" as const,
  "Processed": "Processed" as const,
  "Completed": "Completed" as const,
  "Rejected": "Rejected" as const,
 
});

export const fixedPriceConfiem = Object.freeze({
  "Processed": "Processed" as const,
  "Rejected": "Rejected" as const,
});

export const beforePriceConfiem = Object.freeze({
  // "SentToManager": "SentToManager" as const,
  "ManagerApproved": "ManagerApproved" as const,
  "Rejected": "Rejected" as const,
});

export const editPriceOrderListStatus = Object.freeze({
  "OrderListCreated": "OrderListCreated" as const,
  "SentToManager": "SentToManager" as const,
  "Rejected": "Rejected" as const,
});

export const emailNotification = Object.freeze({
  "Admin": "Admin" as const,
  "Punch Notification": "Punch Notification" as const,
  "Payroll Notification": "Payroll Notification" as const,
});

export const punchSliderItems = Object.freeze({
  "image": "image" as const,
  "video": "video" as const,
});

export const widthofReactQuill = Object.freeze({
  "200px": "200px" as const,
  "300px": "300px" as const,
  "400px": "400px" as const,
});

export const requestStatus = Object.freeze({
  "Accepted": "Accepted" as const,
  "Cancel": "Cancel" as const,
});

export const OrderListItemStatus = Object.freeze({
  "Low": "Low" as const,
  "Normal": "Normal" as const,
  "High": "High" as const,
  "Urgent": "Urgent" as const,
  "Completed": "Completed" as const,
  "Emergency": "Emergency" as const,
});

export const PRIORITY_COLORS: Record<string, string> = {
  Low: "#9E9E9E",              // Gray
  Normal: "#1976D2",           // Blue
  High: "#FB8C00",             // Orange
  Urgent: "#D32F2F",           // Red
  Emergency: "#7F0000",        // Dark Red
  Completed: "#2E7D32",        // Green ✅
};
